import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Environment } from "../environments/environment.interface";
import { ENVIRONMENT } from "../environments/environments.token";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  private readonly httpClient = inject(HttpClient);
  private env: Environment = inject(ENVIRONMENT);

  constructor() {
    this.USER_URL = this.env.USER_API || "";
  }

  private readonly USER_URL: string = "";

  //#region GET.

  GetMobiFixProConfigurations() {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetMobiFixProConfigurations`);
  }

  GetAssetTypeMasterByCID() {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetAssetTypeMasterByCID`);
  }

  GetAssetTypeMasterByID(ID: number) {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetAssetTypeMasterByID?ID=${ID}`);
  }

  GetLocationMasterByCID() {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetLocationMasterByCID`);
  }

  GetLocationMasterByID(ID: number) {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetLocationMasterByID?ID=${ID}`);
  }

  GetAssetMasterByCID() {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetAssetMasterByCID`);
  }

  GetAssetMasterByID(ID: number) {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetAssetMasterByID?ID=${ID}`);
  }

  GetBreakdownsByCID() {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetBreakdownsByCID`);
  }

  GetBreakdownByID(ID: number) {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetBreakdownByID?ID=${ID}`);
  }

  GetBreakDownReasonsByAssetID(AssetID: number) {
    return this.httpClient.get(`${this.USER_URL}/api/mobi-fix-pro-master/GetBreakDownReasonsByAssetID?AssetID=${AssetID}`);
  }

  //#endregion
}
